/**
 * Branded types for units
 */

import type { Brand } from "./Brand"

/**
 * Unix timestamp (seconds since epoch)
 */
export type Time = Brand<number, "Time">

/**
 * Size in bytes
 */
export type Bytes = Brand<number, "Bytes">
